import env from '@/networkRequests/apiClient/env.config'

import logger from '../Logger/logger.functions'
import { BookingRefundSupportEmailParams } from './bookingRefundSupportEmail.types'

export const FULL_REFUND_BOOKING_MESSAGE_MARKER = 'All payments have been refunded'

export const isFullRefundBookingError = (userFriendlyMessage: string): boolean => {
  return userFriendlyMessage.includes(FULL_REFUND_BOOKING_MESSAGE_MARKER)
}

export const buildBookingRefundSupportEmailBody = (params: BookingRefundSupportEmailParams): string => {
  const { apiError, travelerDisplayName, travelerUserId } = params

  return `Hi,

I'm writing because I ran into an error while booking my flight. All payments were refunded.

What happened:
${apiError.message}

Details:
${apiError.userFriendlyMessage}

Error reference:
${apiError.correlationId}

My name: ${travelerDisplayName}
My user ID: ${travelerUserId}

Thank you,
${travelerDisplayName}`
}

export const openBookingRefundSupportEmail = (params: BookingRefundSupportEmailParams): void => {
  try {
    const supportEmailAddress = env.SUPPORT_EMAIL_ADDRESS

    if (!supportEmailAddress) {
      logger.logError(
        new Error('Support email is not configured'),
        'Support email is not configured',
        'openBookingRefundSupportEmail'
      )

      return
    }

    const emailSubject = 'Help with my flight booking (payments refunded)'
    const emailBody = buildBookingRefundSupportEmailBody(params)

    const mailtoUrl = `mailto:${supportEmailAddress}?subject=${encodeURIComponent(
      emailSubject
    )}&body=${encodeURIComponent(emailBody)}`

    window.location.href = mailtoUrl
  } catch (unexpectedError) {
    logger.logError(unexpectedError, 'Failed to open booking refund support email', 'openBookingRefundSupportEmail')
  }
}
